// extracted by mini-css-extract-plugin
module.exports = {"main":"faq_main__iK_Hk","headingForest":"faq_headingForest__g61CV","headingRust":"faq_headingRust__zwcob","first":"faq_first__IpU8P"};